import api from "../services/api";

const EXTENSION_ID = "wa-passkey-connector"; // If we publish it to webstore
// Or we just rely on window.postMessage to any listener installed on the page.

export const detectConnector = async () => {
  return new Promise((resolve) => {
    let timeout = setTimeout(() => {
      resolve(false);
    }, 2000);

    const listener = (event) => {
      if (event.source !== window || !event.data || event.data.type !== "PASSKEY_CONNECTOR_PONG") return;
      clearTimeout(timeout);
      window.removeEventListener("message", listener);
      resolve(true);
    };

    window.addEventListener("message", listener);
    window.postMessage({ type: "PASSKEY_CONNECTOR_PING" }, "*");
  });
};

export const runAssertion = async (whatsappId, options) => {
  return new Promise((resolve, reject) => {
    let timeout = setTimeout(() => {
      reject(new Error("Timeout ao aguardar assinatura do passkey pela extensão"));
    }, 60000);

    const listener = async (event) => {
      if (event.source !== window || !event.data) return;
      
      if (event.data.type === "PASSKEY_CONNECTOR_SUCCESS") {
        clearTimeout(timeout);
        window.removeEventListener("message", listener);
        
        try {
          await api.post(`/whatsapp/${whatsappId}/passkey`, {
            credentialId: event.data.payload.credentialId,
            assertion: event.data.payload.assertion
          });
          resolve(true);
        } catch (err) {
          reject(err);
        }
      } else if (event.data.type === "PASSKEY_CONNECTOR_ERROR") {
        clearTimeout(timeout);
        window.removeEventListener("message", listener);
        reject(new Error(event.data.payload.message || "Erro na assinatura do Passkey"));
      }
    };

    window.addEventListener("message", listener);
    window.postMessage({ 
      type: "PASSKEY_CONNECTOR_RUN", 
      payload: options 
    }, "*");
  });
};
